export default __webpack_public_path__ + "static/media/BOOKONOURSITE.0e8e6273.jpg";